import React, { useState, useEffect, FormEvent, ChangeEvent } from "react";
import { useSelector, useDispatch } from "react-redux";

import moment from "moment";

import { makeStyles } from "@mui/styles";
import Grid2 from "@mui/material/Grid2";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";

import DateTimeField from "app/Components/Fields/DateTimeField";

import { getGameSessions } from "_DatabaseFunctions/directConnect/sessions";
import {
  setFilteredGameSessions,
  setGameSessions,
} from "../../../../store/actions";

const useStyles = makeStyles(() => ({
  root: {
    textAlign: "center",
  },
  Paper: {
    margin: "30px 0px",
    padding: "24px",
    border: "1px solid black",
  },
  Grid: {
    margin: "auto",
  },
  Button: {
    width: "90%",
    color: "white",
    backgroundColor: "teal",
    padding: "12px",
    border: "none",
    cursor: "pointer",
  },
}));

const SearchOptions = () => {
  const user = useSelector((state: any) => state.user.user);

  const dispatch = useDispatch();
  const classes = useStyles();

  const [loading, setLoading] = useState(false);

  const [startTime, setStartTime] = useState(
    `${moment().format("YYYY-MM-DD")}T00:00`,
  );

  const [endTime, setEndTime] = useState(
    `${moment().format("YYYY-MM-DD")}T23:59`,
  );

  const search = async (event: FormEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setLoading(true);
    const sessions = await getGameSessions({
      hostId: user.uid,
      startTime,
      endTime,
    });
    dispatch(setGameSessions(sessions));

    let filteredSessions = sessions.sort((a, b) =>
      a.gameName.localeCompare(b.gameName),
    );
    filteredSessions = filteredSessions.sort(
      (a, b) => a.startTime - b.startTime,
    );
    dispatch(setFilteredGameSessions(filteredSessions));
    setLoading(false);
  };

  return (
    <div>
      <Paper className={classes.Paper} elevation={12}>
        <Grid2 container spacing={3}>
          <Grid2 xs={12} sm={12} className={classes.Grid}>
            <DateTimeField
              label="Start Time"
              value={startTime}
              onChange={(evt: ChangeEvent<HTMLInputElement>) => setStartTime(evt.target.value)}
            />
            <DateTimeField
              label="End Time"
              value={endTime}
              onChange={(evt: ChangeEvent<HTMLInputElement>) => setEndTime(evt.target.value)}
            />
          </Grid2>
          <Grid2 xs={12} sm={12} className={classes.Grid}>
            {loading ? (
              <CircularProgress />
            ) : (
              <button className={classes.Button} onClick={search}>
                Search
              </button>
            )}
          </Grid2>
        </Grid2>
      </Paper>
    </div>
  );
};

export default SearchOptions;
